<ng-container *ngIf="parentFolderId">
  <wk-content-node-selector-panel
    [showSearch]="false"
    [showDropdownSiteList]="false"
    [currentFolderId]="parentFolderId"
    [imageResolver]="imageResolveFunction"
    (select)="onSelect($event)"
    [breadcrumbTransform]="transform"
  >
  </wk-content-node-selector-panel>
</ng-container>
